<div class="modal fade p-0" tabindex="-1" role="dialog" id="loading">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body pt-0">
        <div class="container-fluid">
          <div class="row text-center">
            <div class="col-md-12 ml-auto mt-0">
              @if (!content.animacion) {
                <img src="{{ content.imgTop }}" alt="loading" class="mb-4 mdc-icon-big position-relative {{ content.imgClass }}">
              }
              <div id="loadingAnimation" class="{{ content.imgClass }} m-auto"></div>
            </div>
            <div class="col-md-7 mx-auto ml-auto title mdc-text-secondary mdc-text-1 mdc-text-2 mdc-text-l mdc-line-height">{{ content.titulo }}</div>
            <div class="col-md-7 mx-auto mt-3 ml-auto text mdc-text-dark mdc-text-3-5 mb-4">{{ content.texto }}</div>
            <div class="col-md-12">
              <p class="text-center">
                <img src="assets/img/verifica/loader.gif" alt="loading" class="m-auto">
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>